import { SVGProps } from 'react';

const Vote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9 12 2 2 4-4m7 9H2M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5z"
    />
  </svg>
);
export default Vote;
